
import { Moneda } from "@/shared/types/moneda";
import { createCreditoCondicionPago } from "@/features/facturacion-electronica/utils/condicion-pago-mapper";


interface BuildCreateVentaFERequestParams {
  ventaFormValue: any;
  monedaBase: Moneda;
  dEst: string;
  dPunExp: string;
  monedaOperacionId?: string;
  dTiCam?: number;
  tipoCredito?: "plazo" | "cuotas";
  plazoDias?: string;
  numeroCuotas?: number;
}

export function buildCreateVentaFERequest({
  ventaFormValue,
  monedaBase,
  dEst,
  dPunExp,
  monedaOperacionId,
  dTiCam,
  tipoCredito,
  plazoDias,
  numeroCuotas
}: BuildCreateVentaFERequestParams): any {
  const isCredito = ventaFormValue.credito === true;

  // Construir VentaRequest
  const ventaRequest = {
    vendedorId: ventaFormValue.vendedorId,
    clienteId: ventaFormValue.clienteId,
    depositoId: ventaFormValue.depositoId,
    fecha: ventaFormValue.fecha,
    credito: ventaFormValue.credito || false,
    presupuesto: ventaFormValue.presupuesto || false,
    items: ventaFormValue.items,
    token: ventaFormValue.token,
    auto: ventaFormValue.auto
  };

  // Construir CondicionPago
  const condicionPago: any = {
    iCondOpe: isCredito ? 2 : 1, // 1=contado, 2=crédito
  };

  // Si es crédito, agregar datos de crédito (plazo o cuotas)
  if (isCredito) {
    condicionPago.creditoCondicionPago = createCreditoCondicionPago(tipoCredito, plazoDias, numeroCuotas);
  } else {
    // Si es contado, agregar forma de pago (efectivo por defecto)
    condicionPago.listFormaDePago = [
      {
        iTiPago: 1, // 1=efectivo
        dMonTiPag: ventaFormValue.items.reduce((sum: number, item: any) => sum + (item.precioUnitario * item.cantidad), 0),
        monedaId: monedaBase.id
      }
    ];
  }

  // Construir request completo
  return {
    ventaRequest,
    iTipTra: 1,
    dEst: dEst,
    dPunExp: dPunExp,
    iTipEmi: ventaFormValue.iTipEmi || 1,
    iIndPres: ventaFormValue.iIndPres || 1,
    monedaId: monedaOperacionId || monedaBase.id,
    dCondTiCam: ventaFormValue.dCondTiCam || 1,
    dTiCam: monedaBase.simbolo === "PYG" ? parseFloat((dTiCam ?? 1).toFixed(2)) : parseFloat((1 / (dTiCam ?? 1)).toFixed(2)),
    dDesIndPres: ventaFormValue.dDesIndPres,
    informacionAdicional: ventaFormValue.informacionAdicional,
    condicionPago: condicionPago
  };
}
